import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Leaf, Menu, X } from "lucide-react";

const links = [
    { label: "Services", href: "services" },
    { label: "Standards", href: "standards" },
    { label: "About", href: "about" },
    { label: "Contact", href: "contact" },
];

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-background/80 border-b border-edge">
            <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 h-16">
                <button
                    data-testid="nav-logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="flex items-center gap-2 text-forest"
                >
                    <Leaf className="w-5 h-5" strokeWidth={1.5} />
                    <span className="font-serif text-xl font-medium tracking-tight">The Zami Concept</span>
                </button>

                <div className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-link-${l.href}`}
                            onClick={() => scrollTo(l.href)}
                            className="text-xs font-bold tracking-[0.2em] uppercase text-fern hover:text-forest transition-colors duration-300"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-quote-button"
                        onClick={() => scrollTo("contact")}
                        className="rounded-full bg-forest text-background text-xs font-bold tracking-[0.15em] uppercase px-6 py-2.5 hover:-translate-y-0.5 transition-transform duration-300"
                    >
                        Request a quote
                    </button>
                </div>

                <button
                    data-testid="nav-menu-toggle"
                    className="md:hidden text-forest"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </nav>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.76, 0, 0.24, 1] }}
                        className="md:hidden overflow-hidden border-t border-edge bg-background/95"
                    >
                        <div className="flex flex-col px-6 py-6 gap-5">
                            {links.map((l) => (
                                <button
                                    key={l.href}
                                    data-testid={`nav-mobile-link-${l.href}`}
                                    onClick={() => {
                                        setOpen(false);
                                        scrollTo(l.href);
                                    }}
                                    className="text-left font-serif text-2xl text-forest"
                                >
                                    {l.label}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
}
